import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "Мониторинг",
    date: "Январь-Март 2026",
    title: "Фиксация ограничений",
    color: "",
    description:
      "Сбор доказательств нестабильной работы зарубежных ИТ-ресурсов и инфраструктурных сервисов.",
  },
  {
    status: "Роскомнадзор",
    date: "27 марта 2026",
    title: "Обращение к Роскомнадзору",
    color: "danger",
    description:
      "Обращение рассмотрено Центральным аппаратом Роскомнадзора; мотивированный ответ по существу поставленных вопросов и по правовым основаниям применения мер ограничения доступа не предоставлен.",
  },
  {
    status: "Генеральная прокуратура",
    date: "27 марта 2026",
    title: "Подано обращение",
    color: "danger",
    description:
      "Подано обращение в Генеральную прокуратуру Российской Федерации о проведении проверки законности действий (бездействия) Роскомнадзора.",
  },
  {
    status: "Генеральная прокуратура",
    date: "2 апреля 2026",
    title: "Передача материалов в Роскомнадзор",
    color: "danger",
    description:
      "Генеральная прокуратура Российской Федерации передала материалы в Роскомнадзор для проведения проверки. Исполнение поручения поставлено на контроль Генеральной прокуратуры Российской Федерации.",
  },
  {
    status: "Щёлковский городской суд",
    date: "2 апреля 2026",
    title: "Подано административное исковое заявление",
    color: "success",
    description:
      "Подано административное исковое заявление о признании незаконным действий (бездействия) органов государственной власти.",
  },
  {
    status: "Щёлковский городской суд",
    date: "28 апреля 2026",
    title: "Собеседование (подготовка дела)",
    color: "success",
    description:
      "Назначено собеседование в Щёлковском городском суде для подготовки дела к рассмотрению по существу.",
  },
  {
    status: "Щёлковский городской суд",
    date: "28 апреля 2026",
    title: "Судебный запрос",
    color: "success",
    description:
      "Направлен судебный запрос для получения информации о причинах блокировки/замедления доступа к сервисам YouTube и WhatsApp.",
  },
  {
    status: "Щёлковский городской суд",
    date: "26 мая 2026",
    title: "Рассмотрение по существу",
    color: "success",
    description:
      "Рассмотрение дела по существу в Щёлковском городском суде.",
  },
  {
    status: "Щёлковский городской суд",
    date: "18 июня 2026",
    title: "Производство в части «YouTube» и «WhatsApp» прекращено. В остальной части отказано",
    color: "danger",
    description:
      "Щелковский городской суд вынес решение о прекращении производства в части требований, касающихся сервисов YouTube и WhatsApp, и отказе в иске в части ненадлежащего рассмотрения обращения (ФЗ-59).",
  },
  {
    status: "Московский областной суд",
    date: "23 июня 2026",
    title: "Частная жалоба",
    color: "success",
    description:
      "Подана частная жалоба на определение Щёлковского городского суда о прекращении производства в части требований, касающихся сервисов YouTube и WhatsApp.",
  },
  {
    status: "Московский областной суд",
    date: "23 июня 2026",
    title: "Апелляционная жалоба",
    color: "success",
    description:
      "Подана апелляционная жалоба на определение Щёлковского городского суда об отказе в удовлетворении иска в части ненадлежащего рассмотрения обращения (ФЗ-59).",
  },
];

const initialCaseStatus = {
  label: "В производстве",
  code: "in_progress",
  variant: "in_progress",
};

const LegalCase6Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${css[`caseStatus_${caseStatus.variant}`]
                }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Обжалование действий (бездействия) органов государственной власти</h1>
          <span className={css.caseMeta}>
            Федеральное законодательство · 2026 г.
          </span>
        </div>

        <Link to="https://shelkovo--mo.sudrf.ru/modules.php?name=sud_delo&srv_num=1&name_op=case&case_id=1241042308&case_uid=b3987649-b358-4ca2-b40e-6c578e6a19b0&delo_id=41" target="_blank" rel="noreferrer" className={css.inJustice}>
          <img src={'/emblem_new.png'} alt="Russian Federation" />
          <h3>Дело передается на рассмотрение в Московский областной суд <i className="fi fi-rr-arrow-up-right"></i></h3>
        </Link>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                В суде оспариваются незаконные действия Роскомнадзора по фактической блокировке и искусственному замедлению доступа к сервисам YouTube и WhatsApp с использованием подмены записей в Национальной системе доменных имен (НСДИ) и технических средств противодействия угрозам (ТСПУ). Подробности будут опубликованы позже.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Текущий статус</div>
              <p>
                Подготовка апелляционной и частной жалоб.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://shelkovo--mo.sudrf.ru/modules.php?name=sud_delo&srv_num=1&name_op=case&case_id=1241042308&case_uid=b3987649-b358-4ca2-b40e-6c578e6a19b0&delo_id=41" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Карточка дела в Щёлковском городском суде
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.</p>
    </MainContent>
  );
};

export default LegalCase6Page;